import { common as esCommon } from './es/common';
import { common as enCommon } from './en/common';

const messages = {
  es: {
    common: esCommon
  },
  en: {
    common: enCommon
  }
};

export default messages;